import { PDFDocumentProxy } from 'pdfjs-dist';
import * as React from 'react'
import { Document, Page, pdfjs } from 'react-pdf';
import styled, { css } from 'styled-components';
import { Style } from '../../styles';
import LedgerItemPreviewPlaceholder from './LedgerItemPreviewPlaceholder'

// import.meta requires a module target this project's tsconfig doesn't use; rspack/swc handle it at bundle time regardless.
// @ts-expect-error
const workerUrl = new URL('pdfjs-dist/build/pdf.worker.min.mjs', import.meta.url);
pdfjs.GlobalWorkerOptions.workerSrc = workerUrl.toString();

const Container = styled.div<{ withBorder?: boolean, withBorderRadius?: boolean }>`
	width: 100%;
	height: 100%;
	
	.react-pdf__Page {
		background: transparent !important;
		&:not(:last-child) {
			margin-bottom: 24px;
		}

		${props => props.withBorder && css`
			border: 1px solid ${Style.color.border};
		`}

		${props => props.withBorderRadius && css`
			border-radius: ${Style.variables.baseBorderRadius};
		`}
  }
`

interface IProps {
	file?: string
	currentPage?: number
	width?: number
	height?: number
	allPages?: boolean
	withBorder?: boolean
	withBorderRadius?: boolean
	onLoadSuccess?: (pdf: PDFDocumentProxy) => void
}

interface IState {
	pageCount: number
	reloadKey: number
}

export default class DocumentPreview extends React.Component<IProps, IState> {
	constructor(props: IProps) {
		super(props)

		this.state = {
			pageCount: 0,
			reloadKey: 0,
		}

		this.onLoadSuccess = this.onLoadSuccess.bind(this)
	}

	reload() {
		// file URLs don't change when the underlying PDF is regenerated server-side,
		// so force a remount of <Document> to trigger a re-fetch.
		this.setState(prevState => ({ reloadKey: prevState.reloadKey + 1 }))
	}

	onLoadSuccess(pdf: PDFDocumentProxy) {
		const { onLoadSuccess } = this.props
		this.setState({ pageCount: pdf.numPages })

		if (onLoadSuccess) onLoadSuccess(pdf)
	}

	render() {
		const {
			file,
			allPages,
			withBorder,
			withBorderRadius,
			currentPage,
			width,
		} = this.props
		const { pageCount, reloadKey } = this.state

		return (
			<Container withBorder={withBorder} withBorderRadius={withBorderRadius}>
				<Document
					key={reloadKey}
					file={file}
					onLoadSuccess={this.onLoadSuccess}
					loading={LedgerItemPreviewPlaceholder}
					noData={LedgerItemPreviewPlaceholder}
					error={LedgerItemPreviewPlaceholder}
				>
					{!allPages && <Page
						pageNumber={currentPage}
						width={width}
						loading={LedgerItemPreviewPlaceholder}
						renderAnnotationLayer={false}
						renderTextLayer={false}
					/>}

					{allPages && [...Array(pageCount)].map((_, index) => {
						return (
							<Page
								key={`page_${index + 1}`}
								pageNumber={index + 1}
								width={width}
								loading={LedgerItemPreviewPlaceholder}
								renderAnnotationLayer={false}
								renderTextLayer={false}
							/>
						)
					})}
				</Document>
			</Container>
		)
	}
}